import BaseRepository from '@/api/repositories/BaseRepository';

export default class RentalCarsRepository extends BaseRepository {
    getOnlyFree(damageCaseId) {
        return this.get(`rentalcars/free?damageCaseId=${damageCaseId}`, {});
    }
}
